import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/billing/fakt-legal-entities'

class FaktLegalEntityDataService extends RestApiDataService {
  // Бэк отдаёт Resource-коллекцию { data: [...] }, а не { items: [...] };
  // юрлиц единицы - параметры пагинации не нужны
  getList () {
    return this.http.get(this.baseEntityUrl).then((res) => res.data.data)
  }

  // Смена юрлица у платёжного аккаунта; бэк возвращает обновлённую карточку аккаунта
  assignToAccount (accountId, faktLegalEntityId) {
    return this.http
      .patch(`/billing/payment-accounts/${accountId}/fakt-legal-entity`, { faktLegalEntityId })
      .then((res) => res.data.data)
  }
}

export default new FaktLegalEntityDataService(BASE_ENTITY_URL)
